/**
 * @generated SignedSource<<85c6e2c9cc566fd789d515d41d3dfd8f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type JswProjectMenu$data = {
  readonly projectStyle: JiraProjectStyle | null;
  readonly softwareBoardCount: AGG$Long | null;
  readonly subspaceCount?: AGG$Long | null;
  readonly " $fragmentSpreads": FragmentRefs<"JswExpandableProject" | "JswNonExpandableProject">;
  readonly " $fragmentType": "JswProjectMenu";
};
export type JswProjectMenu$key = {
  readonly " $data"?: JswProjectMenu$data;
  readonly " $fragmentSpreads": FragmentRefs<"JswProjectMenu">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "JswProjectMenu",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "softwareBoardCount"
    },
    {
      "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": "subspaceCount",
              "kind": "ScalarField",
              "name": "subspaceCount_cse"
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "projectStyle"
    },
    {
      "kind": "FragmentSpread",
      "name": "JswNonExpandableProject"
    },
    {
      "kind": "FragmentSpread",
      "name": "JswExpandableProject"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "aac3937718007b5e6d6122bdeb2f5b27";

export default node;
